import { View } from "native-base";
import { useRef, useState } from "react";
import {
  NativeSyntheticEvent, Pressable, TextInput, TextInputContentSizeChangeEventData
} from "react-native";
import { IMessage, InputToolbar, InputToolbarProps } from "react-native-gifted-chat";
import FontAwesome from '@expo/vector-icons/FontAwesome';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
// import AutoGrowingTextInput from "react-native-autogrow-textinput";

export default function ChatFooter({
  onSendChange,
  onPlayPhone
}:{
  onSendChange: (message: IMessage[]) => void;
  onPlayPhone: () => void;
}){
  const [height, setHeight] = useState(42);
  const areaRef = useRef<TextInput>(null);
  const [cacheValue, setCacheValue] = useState<string>("");
  const [giftOpen, setGiftOpen] = useState(false);
  const handleContentSizeChange = (
    event: NativeSyntheticEvent<TextInputContentSizeChangeEventData>
  ) => {
    const { height: newHeight } = event.nativeEvent.contentSize;
    setHeight(newHeight);
  };

  return (
    <View>
      <View style={{
        backgroundImage: "linear-gradient(to top, rgba(19,20,35,1) 0%, rgba(19,20,35,1) 40%, rgba(0,0,0,0))",
        paddingTop: 30,
        padding: 10,
        gap: 10, flexDirection: "row", alignItems: "flex-end",
      }}>
        <Pressable onPress={()=> onPlayPhone() } style={{
          width: 42, height: 42, borderRadius: 10,
          justifyContent: "center", alignItems: "center",
          backgroundImage: "linear-gradient(to right, rgb(148,9,255), rgb(173,8,255))",
        }}>
          <FontAwesome name="phone" size={24} color="#FFFFFF" />
        </Pressable>
        <View style={{ flex: 1, position: "relative", overflow: "hidden" }}>
          <TextInput
            ref={areaRef}
            multiline={true}
            // onContentSizeChange={handleContentSizeChange}
            onChangeText={(e)=>{ setCacheValue(e) }}
            style={{
              backgroundColor: "rgb(33,35,58)",
              borderRadius: 10,
              padding: 10,
              fontSize: 16,
              color: "#FFFFFF",
              maxHeight: 100,
              width: "100%",
              height: height,
              outline: "none",
            }}
            onFocus={()=>{ if(giftOpen) setGiftOpen(false) }}
            placeholder="Enter message"
            placeholderTextColor={"#AAAAAA"}
          />
          <TextInput
            multiline={true}
            value={cacheValue}
            onContentSizeChange={handleContentSizeChange}
            style={{
              padding: 10, fontSize: 16, zIndex: 0, position: "absolute",
              top: 150, left: 0, height: 42, width: "100%",
            }}
            placeholder="Enter message"
            placeholderTextColor={"#AAAAAA"}
          />
        </View>
        <Pressable onPress={()=> {
          // areaRef.current?.clear();
          // setGiftOpen( !giftOpen );
        }} style={{
          width: 42, height: 42, borderRadius: 10,
          justifyContent: "center", alignItems: "center",
          backgroundImage: "linear-gradient(to right, rgb(148,9,255), rgb(173,8,255))",
        }}>
          <FontAwesome6 name="gift" size={18} color="#FFFFFF" />
        </Pressable>
        <Pressable onPress={()=> {
          areaRef.current?.clear();
          onSendChange([{
            _id: new Date().getTime().toString(),
            user: { _id: 1, name: "User" },
            text: cacheValue, createdAt: new Date(), 
          }]);
          setCacheValue("");
        }} style={{
          width: 42, height: 42, borderRadius: 10,
          justifyContent: "center", alignItems: "center",
          backgroundColor: "rgb(33,35,58)",
        }}>
          <FontAwesome name="send" size={18} color="#AAA" />
        </Pressable>
      </View>
      { giftOpen && (
        <View style={{
          height: 100, padding: 10, gap: 10,
          flexDirection: "row",
        }}>
          <Pressable onPress={()=> {
            console.log("hello world");
          }} style={{
            width: 60, height: 60, borderRadius: 10,
            justifyContent: "center", alignItems: "center",
            backgroundColor: "rgb(33,35,58)",
          }}>
            <FontAwesome name="send" size={18} color="#AAA" />
          </Pressable>
        </View>
      )}
    </View>
  )
}